import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { TimeWindow } from '@/types';

export interface TimeWindowSelectorProps {
  selectedTimeWindow: TimeWindow;
  onTimeWindowChange: (window: TimeWindow) => void;
  labels: Record<TimeWindow, string>;
}

export const TimeWindowSelector = ({
  selectedTimeWindow,
  onTimeWindowChange,
  labels,
}: TimeWindowSelectorProps) => (
  <div className="mt-2 flex space-x-1 sm:mt-0">
    {(Object.keys(labels) as TimeWindow[]).map((window) => (
      <Button
        key={window}
        variant={selectedTimeWindow === window ? 'default' : 'outline'}
        onClick={() => onTimeWindowChange(window)}
        className={cn(
          'px-2 py-1 text-xs',
          selectedTimeWindow === window ? 'bg-black text-white' : 'text-black'
        )}>
        {labels[window]}
      </Button>
    ))}
  </div>
);
